/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { PlansRequestBuilderNavigationMetadata, PlansRequestBuilderRequestsMetadata, type PlansRequestBuilder } from './plans/index.js';
// @ts-ignore
import { StatementsRequestBuilderNavigationMetadata, StatementsRequestBuilderRequestsMetadata, type StatementsRequestBuilder } from './statements/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions
 */
export interface CommissionsRequestBuilder extends BaseRequestBuilder<CommissionsRequestBuilder> {
    /**
     * The plans property
     */
    get plans(): PlansRequestBuilder;
    /**
     * The statements property
     */
    get statements(): StatementsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CommissionsRequestBuilderUriTemplate = "{+baseurl}/api/commissions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CommissionsRequestBuilderNavigationMetadata: Record<Exclude<keyof CommissionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    plans: {
        requestsMetadata: PlansRequestBuilderRequestsMetadata,
        navigationMetadata: PlansRequestBuilderNavigationMetadata,
    },
    statements: {
        requestsMetadata: StatementsRequestBuilderRequestsMetadata,
        navigationMetadata: StatementsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
